import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhonePipe } from './phone.pipe';
import { CpfCnpjPipe } from './cpf-cnpj.pipe';
import { EmailPhoneCoverPipe } from './email-phone-cover.pipe';
import { AgencyFormatPipe } from './agency-format.pipe';
import { ComboSearchPipe } from './combo-search.pipe';
import { PercentPipe } from './percent.pipe';

@NgModule({
  declarations: [
    PhonePipe,
    CpfCnpjPipe,
    EmailPhoneCoverPipe,
    AgencyFormatPipe,
    ComboSearchPipe,
    PercentPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
  ],
  providers: [
    DecimalPipe
  ],
  exports: [
    PhonePipe,
    CpfCnpjPipe,
    EmailPhoneCoverPipe,
    AgencyFormatPipe,
    ComboSearchPipe,
    PercentPipe
  ]
})
export class PipesModule {
  constructor() {
  }
}

